import { Typography } from '@components/atoms/typography';
import styled from 'styled-components';

export const NotCorrectVerificationBannerContainer = styled.div`
    padding: 32px 20px;
    border-radius: 8px;
    background-color: ${(props) => props.theme.palette.secondaryA10};
    text-align: center;
`;

export const TypographyContainer = styled(Typography)`
    max-width: 500px;
    margin: 0 auto;
`;
